import { ArrowLeftCircleIcon, ArrowRightCircleIcon } from 'lucide-react'

import { cn } from '@/lib/utils'

export interface DocumentPaginationProps {
  currentPage: number
  totalPages: number
  onChangePage: (page: number) => void
}

export const DocumentPagination = ({ currentPage, totalPages, onChangePage }: DocumentPaginationProps) => {
  const isFirstPage = currentPage === 1
  const isLastPage = currentPage === totalPages

  const isDisabledLeftButton = isFirstPage
  const isDisabledRightButton = isLastPage

  const handleClickLeftButton = () => {
    if (isFirstPage) {
      return
    }
    onChangePage(currentPage - 1)
  }

  const handleClickRightButton = () => {
    if (isLastPage) {
      return
    }
    onChangePage(currentPage + 1)
  }

  return (
    <div className={cn('absolute right-4 top-[50%] translate-y-[-50%]', 'flex items-center gap-x-2')}>
      <button
        type="button"
        className={cn({
          'text-slate-300': isDisabledLeftButton,
        })}
        disabled={isDisabledLeftButton}
        onClick={handleClickLeftButton}
      >
        <ArrowLeftCircleIcon size={16} />
      </button>
      <p className={cn('w-[50px]', 'text-xs font-medium text-slate-500')}>
        page {currentPage}/{totalPages}
      </p>
      <button
        type="button"
        className={cn({
          'text-slate-300': isDisabledRightButton,
        })}
        disabled={isDisabledRightButton}
        onClick={handleClickRightButton}
      >
        <ArrowRightCircleIcon size={16} />
      </button>
    </div>
  )
}
